import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapMutations } from 'vuex';
export default {
  data: function data() {
    return {
      dialogVisible: false
    };
  },
  computed: _objectSpread({}, mapState('d2admin/gray', {
    grayActive: 'active'
  })),
  methods: _objectSpread(_objectSpread({}, mapMutations('d2admin/gray', {
    grayToggle: 'toggle',
    graySet: 'set'
  })), {}, {
    handleDialogOpen: function handleDialogOpen() {
      this.graySet(true);
    },
    handleDialogClosed: function handleDialogClosed() {
      this.graySet(false);
    }
  })
};